import { render, staticRenderFns } from "./BaseProduct.vue?vue&type=template&id=429595f8&scoped=true&"
import script from "./BaseProduct.vue?vue&type=script&lang=js&"
export * from "./BaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./BaseProduct.vue?vue&type=style&index=0&id=429595f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429595f8",
  null
  
)

export default component.exports